import { render } from "./SelectAdv.vue?vue&type=template&id=2b0d29f8"
import script from "./SelectAdv.vue?vue&type=script&lang=js"
export * from "./SelectAdv.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__